export default __webpack_public_path__ + "static/media/angurie.ec64cd82.mp3";